import { ClvrScreenControlHeadersLabelsEnum } from '../enum/ClvrScreenControlHeadersLabelsEnum'

export type headerConfig = {
    children?: Partial<Record<ClvrScreenControlHeadersLabelsEnum, headerConfig>>
}

export type ClvrScreenControlHeaderConfig = Partial<Record<ClvrScreenControlHeadersLabelsEnum, headerConfig>>

export const REF_MATERIAL: ClvrScreenControlHeaderConfig = {
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL_LIST]: {},
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL_TO_PROVIDE]: {},
    [ClvrScreenControlHeadersLabelsEnum.REMARKS]: {},
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL]: {},
}

export const REF_PATIENT: ClvrScreenControlHeaderConfig = {
    [ClvrScreenControlHeadersLabelsEnum.PATIENT_FIRSTNAME]: {},
    [ClvrScreenControlHeadersLabelsEnum.PATIENT_LASTNAME]: {},
    [ClvrScreenControlHeadersLabelsEnum.AGE_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.SEX_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.SERVICE_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.NB_ROOM_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.ADMISSION_TYPE_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.ISOLATION_PATIENT_TYPE]: {},
}

export const ClvrScreenControlHeadersEnumRefLabels: ClvrScreenControlHeaderConfig = {
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL_AND_REMARK]: { children: REF_MATERIAL },
    [ClvrScreenControlHeadersLabelsEnum.PATIENT]: { children: REF_PATIENT },
}

export const AGGREGATED_DATA_TYPES: ClvrScreenControlHeadersLabelsEnum[] = [
    ClvrScreenControlHeadersLabelsEnum.INTERVENTION,
    ClvrScreenControlHeadersLabelsEnum.MATERIAL_TO_PROVIDE,
    ClvrScreenControlHeadersLabelsEnum.MATERIAL_LIST,
    ClvrScreenControlHeadersLabelsEnum.REMARKS,
    ClvrScreenControlHeadersLabelsEnum.MATERIAL,
]

export const TRIGRAM_DATA_TYPES: ClvrScreenControlHeadersLabelsEnum[] = [
    ClvrScreenControlHeadersLabelsEnum.NURSE_ROOM_HELPERS,
    ClvrScreenControlHeadersLabelsEnum.NURSE_INSTRUMENTALIST,
    ClvrScreenControlHeadersLabelsEnum.NURSE_ANESTHETIST,
]
